import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './admin.routing';
import { AppComponent } from '../app.component';
import { DealerHomeComponent } from './home/dealer-home/dealer-home.component';

import { AuthGuard } from '../auth.guard';
import { AdminService } from './services/admin.service';

import { ListComponent } from './list/list.component';
import { VendorComponent } from './vendor/vendor.component';
import { RoleComponent } from './role/role.component';
import { EditComponent } from './edit/edit.component';
import { AreaListComponent } from './area/area-list/area-list.component';
import { AreaEditComponent } from './area/area-edit/area.edit.component';
import { SubareaComponent } from './subarea/subarea.component';
import { CrewComponent } from './crew/crew.component';
import { FieldTechnicianComponent } from './field-technician/field.technician.component';
import { ResourceComponent } from './resource/resource.component';
import { ItemTypeComponent } from './item-type/item-type.component';
import { ItemListComponent } from './item/item-list/item-list.component';
import { ItemEditComponent } from './item/item-edit/item-edit.component';
import { WarehouseComponent } from './warehouse/warehouse.component';
import { WarehouselocationComponent } from './warehouselocation/warehouselocation.component';
import { ProjectManagementComponent } from './project-management/project.management.component';
import { BusinessManagementComponent } from './business-management/business.management.component';
import { OfficeDialog } from './office/office.dialog';
import { QuoteTemplateComponent, QuoteTemplateNameDialog } from './quote/quote-template/quote-template.component';
import { BulkUpdateComponent } from './item/bulk-update/bulk-update.component';
import { ItemSourceListComponent } from './item-source/item-source-list/item-source-list.component';
import { ItemSourceEditComponent } from './item-source/item-source-edit/item-source-edit.component';
import { AdminComponent } from './admin.component';
import { BulkUpdateRollbackComponent } from './item/bulk-update-rollback/bulk-update-rollback.component';
import { AreaSourceEditComponent } from './area-source/area-source-edit/area.source.edit.component';
import { SubareaSourceEditComponent } from './subarea-source/subarea-source.component';
import { AreaSourceListComponent } from './area-source/area-source-list/area-source-list.component';
import { DocumentComponent } from './document/document.component';
import { QuillModule } from 'ngx-quill';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ImportItemQtyComponent } from './item/import-item-qty/import-item-qty.component';
import { ImportItemSourceComponent } from './item/import-item-source/import-item-source.component';
import { EventService } from '../shared/services/event.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule,
    QuillModule,
    DragDropModule,
  ],
  declarations: [
    DealerHomeComponent, ListComponent, VendorComponent, RoleComponent, EditComponent,
    AreaEditComponent, SubareaComponent, AreaSourceEditComponent, SubareaSourceEditComponent,
    CrewComponent, FieldTechnicianComponent, ItemTypeComponent, ItemListComponent, ItemEditComponent, ResourceComponent, 
    ItemSourceListComponent, ImportItemSourceComponent, WarehouseComponent, WarehouselocationComponent, 
    ProjectManagementComponent, BusinessManagementComponent,
    OfficeDialog,
    AreaListComponent, AreaSourceListComponent,
    QuoteTemplateComponent, QuoteTemplateNameDialog,
    BulkUpdateComponent,
    ItemSourceEditComponent,
    BulkUpdateRollbackComponent,
    DocumentComponent,
    ImportItemQtyComponent],
  exports: [],
  providers: [AppComponent, AuthGuard, AdminService, EventService]
})
export class AdminModule { }
